// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { PageContext } from "@/features/assistant/types";

const SUGGESTION_KEYS = ["q1", "q2", "q3"] as const;

export function EmptyState({ context, onPick }: { context: PageContext | null; onPick: (question: string) => void }) {
  const { t } = useTranslation();
  const kind = context?.kind ?? "none";
  return (
    <div className="flex flex-col items-center pt-8 text-center">
      <span className="flex size-10 items-center justify-center rounded-full bg-primary text-primary-foreground">
        <Sparkles className="size-5" />
      </span>
      <h2 className="mt-3 font-semibold text-base">
        {context ? t("assistant.empty.heading", { context: context.label }) : t("assistant.empty.headingGeneric")}
      </h2>
      <p className="mt-1 text-muted-foreground text-sm">{t("assistant.empty.explainer")}</p>
      <div className="mt-6 flex w-full flex-col gap-2">
        {SUGGESTION_KEYS.map((key) => {
          const question = t(`assistant.suggestions.${kind}.${key}`);
          return (
            <button
              key={key}
              type="button"
              onClick={() => onPick(question)}
              className="rounded-lg border px-3 py-2 text-left text-sm transition-colors hover:border-primary hover:bg-primary/5"
            >
              {question}
            </button>
          );
        })}
      </div>
    </div>
  );
}
